import React from 'react';
import { Toaster } from 'react-hot-toast';

const ToastProvider: React.FC = () => {
  return (
    <Toaster
      position="top-right"
      reverseOrder={false}
      gutter={8}
      containerClassName=""
      containerStyle={{}}
      toastOptions={{
        duration: 4000,
        style: {
          background: '#363636',
          color: '#fff',
        },
        success: {
          duration: 3000,
          style: {
            background: '#d1fae5',
            color: '#059669',
          },
        },
        error: {
          duration: 5000,
          style: {
            background: '#fee2e2',
            color: '#dc2626',
          },
        },
      }}
    />
  );
};

export default ToastProvider;
